import React, { useEffect, useState, useMemo } from "react";
import { Row, Input, FormGroup, Label,Form } from "reactstrap";
import { Card, CardBody, CardTitle } from "reactstrap";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { useHistory, useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import countryList from "react-select-country-list";
import GooglePlacesComponent from "../../../../candidateinfo/GooglePlacesComponent";
import { ProfileService } from "../../../../../services/ProfileService";
import { Stringutility } from "../../../../../utilities/stringutility";
import { Constants } from "../../../../../constants/constantValues";

const CandidateAddExperience = () => {

  const location = useLocation();
  const receivedData = location.state;
  var experienceId = "";
  if (!Stringutility.isNullOrEmpty(receivedData)) {
    experienceId = receivedData.id;
  }

  const history = useHistory();
  const countries = useMemo(() => countryList().getData(), []);
  const [inputField, setInputField] = useState({
    position: "",
    employer: "",
    description: "",
  });

  const [inputAddressField, setInputAddressField] = useState({
    street: "",
    area: "",
    city: "",
    state: "",
    zipcode: "",
    latitude: "",
    longitude: "",
  });

  const [country, setCountry] = useState({
    value: "US",
    label: "United States",
  });
  const [countr, setCountr] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectdCounty, setSelectedCountry] = useState("United States");

  const [certificationsList, setCandidateCertificationList] = useState([]);
  const [candidateSkills, setCandidateSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [saveBtnEnabled, setSaveBtnEnabled] = useState(false);

  const handleCallback = (googlePlaces) => {
    setInputAddressField((prevState) => ({
      ...prevState,
      street: googlePlaces.street,
      area: googlePlaces.area,
      city: googlePlaces.city,
      state: googlePlaces.state,
      zipcode: googlePlaces.zipcode,
      latitude: googlePlaces.latitude,
      longitude: googlePlaces.longitude,
    }));

    countries.map((country) => {
      if (country.label === googlePlaces.country) {
        setCountry(country);
        setSelectedCountry(googlePlaces.country);
      }
    });
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const inputAddressHandler = (e) => {
    const { name, value } = e.target;
    setInputAddressField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onBackPressed = () => {
    history.goBack();
  };

  const cancelButton = () => {
    history.goBack();
  };

  const submitButton = () => {
    let position = inputField.position;
    if (Stringutility.getValue(position) == "") {
      Stringutility.showErrorMessage(Constants.enterPosition);
      return;
    }

    let employer = inputField.employer;
    if (Stringutility.getValue(employer) == "") {
      Stringutility.showErrorMessage(Constants.enterEmployer);
      return;
    }

    if (Stringutility.getValue(startDate) == "") {
      Stringutility.showErrorMessage(Constants.enterStartDate);
      return;
    }

    if (endDate > 0) {
      var start_date = new Date(startDate).getTime();
      var end_date = new Date(endDate).getTime();

      if (start_date > end_date) {
        Stringutility.showErrorMessage(Constants.endDateGraterThanStartDate);
        return;
      }
    }

    let city = inputAddressField.city;
    if (Stringutility.getValue(city) == "") {
      Stringutility.showErrorMessage(Constants.enterCity);
      return;
    }

    let state = inputAddressField.state;
    if (Stringutility.getValue(state) == "") {
      Stringutility.showErrorMessage(Constants.enterState);
      return;
    }

    if (Stringutility.isNullOrEmpty(selectdCounty)) {
      Stringutility.showErrorMessage(Constants.selectCountry);
      return;
    }

    const moAddress = {
      city: city,
      state: state,
      country: selectdCounty,
      zipcode: inputAddressField.zipcode,
      latitude: inputAddressField.latitude,
      longitude: inputAddressField.longitude,
    };
    let edate = 0;
    if (endDate == null) {
      edate = -1;
    } else {
      edate = new Date(endDate).getTime();
    }
    const addExperienceReqest = {
      position: inputField.position,
      employer: inputField.employer,
      startDate: new Date(startDate).getTime(),
      endDate: edate,
      description: inputField.description,
      address: moAddress,
      skills: selectedSkills,
    };
    if (experienceId !== "") {
      setSaveBtnEnabled(true);
      ProfileService.editExperience(
        addExperienceReqest,
        experienceId
      ).then((response) => {
        setSaveBtnEnabled(false);
        try {
          // toast.success("Job experience updated successfully");
          history.goBack();
        } catch (err) {
          console.error("editExperience" + JSON.stringify(err));
        }
      });
    } else {
      setSaveBtnEnabled(true);
      ProfileService.addExperience(addExperienceReqest).then((response) => {
        setSaveBtnEnabled(false);
        try {
          // toast.success("Job experience added successfully");
          history.goBack();
        } catch (err) {
          console.error("addExperience" + JSON.stringify(err));
        }
      });
    }
  };

  const handleCountrySelectChange = (value) => {
    setCountry(value);
    setSelectedCountry(value.label);
  };

  let count = 0;
  useEffect(() => {
    if (!Stringutility.isNullOrEmpty(experienceId)) {
      getCandidateExperience();
    }
    getCandidateSkillList();
    getTotalCandidateCertificationsList();
  }, [count]);

  const getCandidateExperience = () => {  
    ProfileService.getExperienceById(experienceId).then((response) => {
      try {
        if (response.data != null) {
          var experienceDetails = response.data;

          let position = Stringutility.getValue(experienceDetails.position);
          let employer = Stringutility.getValue(experienceDetails.employer);
          let description = Stringutility.getValue(
            experienceDetails.description
          );
          let startDate = Stringutility.getValue(experienceDetails.startDate);
          let endDate = Stringutility.getValue(experienceDetails.endDate);

          setInputField((prevState) => ({
            ...prevState,
            position: position,
            employer: employer,
            description: description,
          }));

          if (!Stringutility.isNullOrEmpty(startDate)) {
            if (startDate > 0) {
              setStartDate(new Date(startDate));
            } else if (startDate == 0) {
              setStartDate();
            }
          }

          if (!Stringutility.isNullOrEmpty(endDate)) {
            if (endDate > 0) {
              setEndDate(new Date(endDate));
            } else if (endDate == 0 ||  Present == true) {
              setEndDate();
              setPresent(true);
            }
          }

          let address = experienceDetails.address;
          if (address != null) {
            let city = Stringutility.getValue(address.city);
            let state = Stringutility.getValue(address.state);
            let zipcode = Stringutility.getValue(address.zipcode);
            let latitude = Stringutility.getValue(address.latitude);
            let longitude = Stringutility.getValue(address.longitude);
            let addressCountry = Stringutility.getValue(address.country);

            setInputAddressField((prevState) => ({
              ...prevState,
              city: city,
              state: state,
              zipcode: zipcode,
              latitude: latitude,
              longitude: longitude,
            }));

            if (addressCountry != "") {
              countries.map((country) => {
                if (country.label == addressCountry) {
                  setCountry(country);
                  setSelectedCountry(addressCountry);
                }
              });
            }
          }

          if (response.data.skills !== null) {
            var list = [...selectedSkills];
            response.data.skills.length > 0 &&
              response.data.skills.map((skill) => {
                list.push(skill.skillId);
              });
            setSelectedSkills(list);
          }
        }
      } catch (err) {
        console.error("getExperience" + JSON.stringify(err));
      }
    });
  };

  const handleSkillCheck = (event, skill, index) => {
    var updatedList = [...selectedSkills];
    if (event.target.checked) {
      updatedList.push(skill.skillId);
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == skill.skillId) {
          updatedList.splice(i, 1);
        }
      }
    }
    setSelectedSkills(updatedList);
  };

  const handleCerificationCheck = (event, skill, index) => {
    var updatedList = [...selectedSkills];
    if (event.target.checked) {
      updatedList.push(skill.skillId);
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == skill.skillId) {
          updatedList.splice(i, 1);
        }
      }
    }
    setSelectedSkills(updatedList);
  };
  const [Present,setPresent] = useState(false);

  const showPresent = ()=>{
    setPresent(!Present)
    setEndDate(0)
   
  }
  const getTotalCandidateCertificationsList = () => {
    ProfileService.getProfileCertifications().then((response) => {
      try {
        if (response.data != null) {
          setCandidateCertificationList(response.data.skills);
        }
      } catch (err) {
        console.error("getProfileCertifications" + JSON.stringify(err));
      }
    });
  };

  const getCandidateSkillList = () => {
    ProfileService.getProfileSkills().then((response) => {
      try {
        if (response.data != null) {
          setCandidateSkills(response.data.skills);
        }
      } catch (err) {
        console.error("getProfileSkills" + JSON.stringify(err));
      }
    });
  };

  return (
    <div className="basicinfo_container min-sm:col-span-2 max-sm:-mt-[120px] ">
      <div className="Container-box t-sal-margin-top">
        <div className="bg-primary-white min-sm:rounded-xl shadow-lg pt-12 mb-8 p-3">
          <div className="col-sm-12">
            <div>
              <div className="addexperience right">
                <div className="skill-header">
                  <div>
                    <div className="profile-card-title">
                      <Label className=" font-bold card-title-experience t-h2-font-sm">
                        {experienceId !== ""
                          ? "Update Experience"
                          : "Add Experience"}
                      </Label>
                      <div className="horizontal_line" />
                    </div>
                  </div>
                </div>
                <Form className="mt-4">
                  <FormGroup row>
                    <Colxx sm={8}>
                      <FormGroup>
                        <Label data-testid="candidateaddexperience-forms.name">
                          Position*
                        </Label>

                        <Input
                          className="t-rounded-lg"
                          type="text"
                          data-testid="candidateaddexperience-position"
                          name="position"
                          onChange={inputsHandler}
                          value={inputField.position}
                        />
                      </FormGroup>
                    </Colxx>

                    <Colxx sm={8}>
                      <FormGroup>
                        <Label data-testid="candidateaddexperience-forms.employer">
                          Employer*
                        </Label>
                        <Input
                          type="text"
                          className="t-rounded-lg"
                          data-testid="candidateaddexperience-employer"
                          name="employer"
                          onChange={inputsHandler}
                          value={inputField.employer}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx sm={12}>
                      <Row>
                      <Colxx sm={6}>
                          <FormGroup>
                          <Input type="checkbox"  className="ml-1" checked={Present} onChange={showPresent}/>
                            <Label className="ml-5">I am currently working in this role</Label>
                            </FormGroup>
                        </Colxx>
                      </Row>
                    </Colxx>
                    <Colxx sm={12}>
                      <Row>
                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>Start date*</Label>
                            <div>
                              <DatePicker
                                className="form-control t-rounded-lg"
                                selected={startDate}
                                onChange={setStartDate}
                                dateFormat="MM/yyyy"
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                showMonthYearPicker
                                dropdownMode="select"
                              />
                            </div>
                          </FormGroup>
                        </Colxx>

                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>End date</Label>
                            <DatePicker
                              className="form-control t-rounded-lg"
                              selected={endDate}
                              onChange={setEndDate}
                              maxDate={new Date()}
                              dateFormat="MM/yyyy"
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              showMonthYearPicker
                              dropdownMode="select"
                              disabled={Present == true }
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </Colxx>
                    <Colxx sm={12}>
                        <Label>Address </Label>
                    </Colxx>

                    <Colxx sm={8}>
                    <FormGroup>
                      <GooglePlacesComponent parentCallback={handleCallback} />
                      </FormGroup>
                    </Colxx>

                    <Colxx sm={12}>
                      <Row>
                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>City*</Label>
                            <Input
                              className="t-rounded-lg"
                              type="text"
                              data-testid="candidateaddexperience-city"
                              name="city"
                              onChange={inputAddressHandler}
                              value={inputAddressField.city}
                            />
                          </FormGroup>
                        </Colxx>

                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>State*</Label>
                            <Input
                              className="t-rounded-lg"
                              type="text"
                              data-testid="candidateaddexperience-state"
                              name="state"
                              onChange={inputAddressHandler}
                              value={inputAddressField.state}
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </Colxx>
                    <Colxx sm={12}>
                      <Row>
                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>Zipcode </Label>
                            <Input
                              className="t-rounded-lg"
                              type="text"
                              data-testid="candidateaddexperience-zipcode"
                              name="zipcode"
                              onChange={inputAddressHandler}
                              value={inputAddressField.zipcode}
                            />
                          </FormGroup>
                        </Colxx>

                        <Colxx sm={4}>
                          <FormGroup>
                            <Label>Country*</Label>
                            <Select
                              value={country}
                              type="select"
                              onChange={handleCountrySelectChange}
                              options={countries}
                            ></Select>
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </Colxx>

                    <Colxx sm={12}>
                      <FormGroup>
                        <Label>Description</Label>
                        <Input
                          rows="6"
                          className="t-rounded-lg"
                          data-testid="candidateaddexperience-description"
                          type="textarea"
                          name="description"
                          onChange={inputsHandler}
                          value={inputField.description}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx></Colxx>
                  </FormGroup>
                </Form>

                <div>
                  {candidateSkills.length > 0 && (
                    <Row>
                      <Colxx sm={12}>
                        <Card>
                          <CardBody>
                            <CardTitle>
                              <strong>Skills</strong>
                              <p> Select skills relevant to this experience</p>
                            </CardTitle>
                            {candidateSkills.length > 0 &&
                              candidateSkills.map((skill, index) => {
                                return (
                                  <div className="tracbox" key={index}>
                                    <label className="terms">
                                      <input
                                        id={skill.skillId}
                                        type="checkbox"
                                        name={skill.name}
                                        className="input_skill"
                                        checked={selectedSkills.includes(skill.skillId)}
                                        onChange={(e) =>
                                          handleSkillCheck(e, skill)
                                        }
                                      />{" "}
                                      {skill.name}
                                    </label>
                                  </div>
                                );
                              })}
                            <p>
                              If you would like to add skills, first save this
                              experience, go to Add Skills, and come back here
                              by clicking Job Experience.{" "}
                            </p>
                          </CardBody>
                        </Card>
                      </Colxx>
                    </Row>
                  )}

                  {certificationsList.length > 0 && (
                    <Row className="mt-2">
                      <Colxx sm={12}>
                        <Card>
                          <CardBody>
                            <CardTitle>
                              <strong>Certifications</strong>
                            </CardTitle>
                            <p>
                              {" "}
                              Select certifications relevant to this experience
                            </p>
                            {certificationsList.length > 0 &&
                              certificationsList.map((cerification, index) => {
                                return (
                                  <div key={index} className="tracbox">
                                    <label className="terms">
                                      <input
                                          id={cerification.skillId}
                                          type="checkbox"
                                          className="input_skill t-rounded-lg"
                                          checked={selectedSkills.includes(cerification.skillId)}
                                          onChange={(e) => handleCerificationCheck(e, cerification)}
                                        /> {" "}
                                      {cerification.name}
                                    </label>
                                  </div>
                                );
                              })}
                            <p>
                              If you would like to add certifications, first
                              save this experience, go to Add Certifications,
                              and come back here by clicking Job Experience.{" "}
                            </p>
                          </CardBody>
                        </Card>
                      </Colxx>
                    </Row>
                  )}
                </div>

                <div className="mt-4">
                  <TeamanicsButton
                    onClick={cancelButton}
                  >
                    Cancel
                  </TeamanicsButton>
                  <TeamanicsButton
                    className="ml-2"
                    disabled={saveBtnEnabled}
                    onClick={submitButton}
                  >
                    {experienceId !== ""
                      ? "Update"
                      : "Save"}
                  </TeamanicsButton>

                </div>
              </div>
              <div className="mb-5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateAddExperience;
